// @ts-nocheck
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AgreeEchoesConsentBody,
  CheckStripePaymentMethod200,
  FilePutSignedUrl200,
  FilePutSignedUrlBody,
  InvoiceList200,
  InvoiceListParams,
  OperationRuleCreate201,
  OperationRuleCreateBody,
  OperationRuleList200,
  OperationRuleListParams,
  OwnerMemoCreate201,
  OwnerMemoCreate400,
  OwnerMemoCreateBody,
  OwnerMemoGet200,
  OwnerMemoGetParams,
  OwnerMemoList200,
  OwnerMemoListParams,
  OwnerMemoUpdateBody,
  OwnerSummary200,
  PlanCancelBody,
  PlanCreate201,
  PlanCreateBody,
  PlanGet200,
  PlanGetParams,
  PropertyCreate201,
  PropertyCreateBody,
  PropertyGet200,
  PropertyGetParams,
  PropertyList200,
  PropertyListParams,
  PropertyPublicList200,
  PropertyPublicListParams,
  PropertyUpdateBody,
  RoomCreate201,
  RoomCreateBody,
  RoomGet200,
  RoomGetParams,
  RoomList200,
  RoomListParams,
  RoomUpdateBody,
  TenantApplicationCreate201,
  TenantApplicationCreateBody,
  TenantApplicationGet200,
  TenantApplicationGetParams,
  TenantApplicationUpdateBody,
  TenantApplicationUpdateStatusBody,
  TenantCancelBody,
  TenantCreate201,
  TenantCreateBody,
  TenantGet200,
  TenantGetParams,
  TenantUpdateBody,
  TicketCreate201,
  TicketCreateBody,
  TicketGet200,
  TicketGetParams,
  TicketList200,
  TicketListParams,
  TicketMessageCreate201,
  TicketMessageCreateBody,
  TicketMessageList200,
  TicketMessageListParams,
  TicketUpdateBody,
  TicketUpdateContractorBody
} from '../models';

import { customInstance } from '../../instance';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary propertyPublicList
 */
export const getPropertyPublicListUrl = (params?: PropertyPublicListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/properties/public-list?${stringifiedParams}` : `/properties/public-list`
}

export const propertyPublicList = async (params?: PropertyPublicListParams, options?: RequestInit): Promise<PropertyPublicList200> => {
  
  return customInstance<PropertyPublicList200>(getPropertyPublicListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getPropertyPublicListQueryKey = (params?: PropertyPublicListParams,) => {
    return [`/properties/public-list`, ...(params ? [params]: [])] as const;
    }

    
export const getPropertyPublicListQueryOptions = <TData = Awaited<ReturnType<typeof propertyPublicList>>, TError = unknown>(params?: PropertyPublicListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyPublicList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPropertyPublicListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof propertyPublicList>>> = ({ signal }) => propertyPublicList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof propertyPublicList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PropertyPublicListQueryResult = NonNullable<Awaited<ReturnType<typeof propertyPublicList>>>
export type PropertyPublicListQueryError = unknown


export function usePropertyPublicList<TData = Awaited<ReturnType<typeof propertyPublicList>>, TError = unknown>(
 params: undefined |  PropertyPublicListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyPublicList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof propertyPublicList>>,
          TError,
          Awaited<ReturnType<typeof propertyPublicList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyPublicList<TData = Awaited<ReturnType<typeof propertyPublicList>>, TError = unknown>(
 params?: PropertyPublicListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyPublicList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof propertyPublicList>>,
          TError,
          Awaited<ReturnType<typeof propertyPublicList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyPublicList<TData = Awaited<ReturnType<typeof propertyPublicList>>, TError = unknown>(
 params?: PropertyPublicListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyPublicList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary propertyPublicList
 */

export function usePropertyPublicList<TData = Awaited<ReturnType<typeof propertyPublicList>>, TError = unknown>(
 params?: PropertyPublicListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyPublicList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPropertyPublicListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPropertyPublicListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof propertyPublicList>>, TError = unknown>(params?: PropertyPublicListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyPublicList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPropertyPublicListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof propertyPublicList>>> = ({ signal }) => propertyPublicList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyPublicList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PropertyPublicListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof propertyPublicList>>>
export type PropertyPublicListSuspenseQueryError = unknown


export function usePropertyPublicListSuspense<TData = Awaited<ReturnType<typeof propertyPublicList>>, TError = unknown>(
 params: undefined |  PropertyPublicListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyPublicList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyPublicListSuspense<TData = Awaited<ReturnType<typeof propertyPublicList>>, TError = unknown>(
 params?: PropertyPublicListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyPublicList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyPublicListSuspense<TData = Awaited<ReturnType<typeof propertyPublicList>>, TError = unknown>(
 params?: PropertyPublicListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyPublicList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary propertyPublicList
 */

export function usePropertyPublicListSuspense<TData = Awaited<ReturnType<typeof propertyPublicList>>, TError = unknown>(
 params?: PropertyPublicListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyPublicList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPropertyPublicListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary ファイルアップロード用署名付きURL取得
 */
export const getFilePutSignedUrlUrl = () => {


  

  return `/files/put-signed-url`
}

export const filePutSignedUrl = async (filePutSignedUrlBody: FilePutSignedUrlBody, options?: RequestInit): Promise<FilePutSignedUrl200> => {
  
  return customInstance<FilePutSignedUrl200>(getFilePutSignedUrlUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      filePutSignedUrlBody,)
  }
);}




export const getFilePutSignedUrlMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filePutSignedUrl>>, TError,{data: FilePutSignedUrlBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof filePutSignedUrl>>, TError,{data: FilePutSignedUrlBody}, TContext> => {

const mutationKey = ['filePutSignedUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof filePutSignedUrl>>, {data: FilePutSignedUrlBody}> = (props) => {
          const {data} = props ?? {};

          return  filePutSignedUrl(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FilePutSignedUrlMutationResult = NonNullable<Awaited<ReturnType<typeof filePutSignedUrl>>>
    export type FilePutSignedUrlMutationBody = FilePutSignedUrlBody
    export type FilePutSignedUrlMutationError = unknown

    /**
 * @summary ファイルアップロード用署名付きURL取得
 */
export const useFilePutSignedUrl = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filePutSignedUrl>>, TError,{data: FilePutSignedUrlBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof filePutSignedUrl>>,
        TError,
        {data: FilePutSignedUrlBody},
        TContext
      > => {

      const mutationOptions = getFilePutSignedUrlMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary invoiceList
 */
export const getInvoiceListUrl = (params?: InvoiceListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/invoices?${stringifiedParams}` : `/invoices`
}

export const invoiceList = async (params?: InvoiceListParams, options?: RequestInit): Promise<InvoiceList200> => {
  
  return customInstance<InvoiceList200>(getInvoiceListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getInvoiceListQueryKey = (params?: InvoiceListParams,) => {
    return [`/invoices`, ...(params ? [params]: [])] as const;
    }

    
export const getInvoiceListQueryOptions = <TData = Awaited<ReturnType<typeof invoiceList>>, TError = unknown>(params?: InvoiceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvoiceListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof invoiceList>>> = ({ signal }) => invoiceList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invoiceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvoiceListQueryResult = NonNullable<Awaited<ReturnType<typeof invoiceList>>>
export type InvoiceListQueryError = unknown


export function useInvoiceList<TData = Awaited<ReturnType<typeof invoiceList>>, TError = unknown>(
 params: undefined |  InvoiceListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invoiceList>>,
          TError,
          Awaited<ReturnType<typeof invoiceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvoiceList<TData = Awaited<ReturnType<typeof invoiceList>>, TError = unknown>(
 params?: InvoiceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invoiceList>>,
          TError,
          Awaited<ReturnType<typeof invoiceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvoiceList<TData = Awaited<ReturnType<typeof invoiceList>>, TError = unknown>(
 params?: InvoiceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary invoiceList
 */

export function useInvoiceList<TData = Awaited<ReturnType<typeof invoiceList>>, TError = unknown>(
 params?: InvoiceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvoiceListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvoiceListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof invoiceList>>, TError = unknown>(params?: InvoiceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof invoiceList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvoiceListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof invoiceList>>> = ({ signal }) => invoiceList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof invoiceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvoiceListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof invoiceList>>>
export type InvoiceListSuspenseQueryError = unknown


export function useInvoiceListSuspense<TData = Awaited<ReturnType<typeof invoiceList>>, TError = unknown>(
 params: undefined |  InvoiceListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof invoiceList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvoiceListSuspense<TData = Awaited<ReturnType<typeof invoiceList>>, TError = unknown>(
 params?: InvoiceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof invoiceList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvoiceListSuspense<TData = Awaited<ReturnType<typeof invoiceList>>, TError = unknown>(
 params?: InvoiceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof invoiceList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary invoiceList
 */

export function useInvoiceListSuspense<TData = Awaited<ReturnType<typeof invoiceList>>, TError = unknown>(
 params?: InvoiceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof invoiceList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvoiceListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary operationRuleList
 */
export const getOperationRuleListUrl = (params?: OperationRuleListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/operation-rules?${stringifiedParams}` : `/operation-rules`
}

export const operationRuleList = async (params?: OperationRuleListParams, options?: RequestInit): Promise<OperationRuleList200> => {
  
  return customInstance<OperationRuleList200>(getOperationRuleListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getOperationRuleListQueryKey = (params?: OperationRuleListParams,) => {
    return [`/operation-rules`, ...(params ? [params]: [])] as const;
    }

    
export const getOperationRuleListQueryOptions = <TData = Awaited<ReturnType<typeof operationRuleList>>, TError = unknown>(params?: OperationRuleListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationRuleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationRuleListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationRuleList>>> = ({ signal }) => operationRuleList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationRuleList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationRuleListQueryResult = NonNullable<Awaited<ReturnType<typeof operationRuleList>>>
export type OperationRuleListQueryError = unknown


export function useOperationRuleList<TData = Awaited<ReturnType<typeof operationRuleList>>, TError = unknown>(
 params: undefined |  OperationRuleListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationRuleList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationRuleList>>,
          TError,
          Awaited<ReturnType<typeof operationRuleList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationRuleList<TData = Awaited<ReturnType<typeof operationRuleList>>, TError = unknown>(
 params?: OperationRuleListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationRuleList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationRuleList>>,
          TError,
          Awaited<ReturnType<typeof operationRuleList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationRuleList<TData = Awaited<ReturnType<typeof operationRuleList>>, TError = unknown>(
 params?: OperationRuleListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationRuleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary operationRuleList
 */

export function useOperationRuleList<TData = Awaited<ReturnType<typeof operationRuleList>>, TError = unknown>(
 params?: OperationRuleListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationRuleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationRuleListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOperationRuleListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationRuleList>>, TError = unknown>(params?: OperationRuleListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationRuleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationRuleListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationRuleList>>> = ({ signal }) => operationRuleList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationRuleList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationRuleListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationRuleList>>>
export type OperationRuleListSuspenseQueryError = unknown


export function useOperationRuleListSuspense<TData = Awaited<ReturnType<typeof operationRuleList>>, TError = unknown>(
 params: undefined |  OperationRuleListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationRuleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationRuleListSuspense<TData = Awaited<ReturnType<typeof operationRuleList>>, TError = unknown>(
 params?: OperationRuleListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationRuleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationRuleListSuspense<TData = Awaited<ReturnType<typeof operationRuleList>>, TError = unknown>(
 params?: OperationRuleListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationRuleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary operationRuleList
 */

export function useOperationRuleListSuspense<TData = Awaited<ReturnType<typeof operationRuleList>>, TError = unknown>(
 params?: OperationRuleListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationRuleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationRuleListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary operationRuleCreate
 */
export const getOperationRuleCreateUrl = () => {


  

  return `/operation-rules`
}

export const operationRuleCreate = async (operationRuleCreateBody: OperationRuleCreateBody, options?: RequestInit): Promise<OperationRuleCreate201> => {
  
  return customInstance<OperationRuleCreate201>(getOperationRuleCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      operationRuleCreateBody,)
  }
);}




export const getOperationRuleCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationRuleCreate>>, TError,{data: OperationRuleCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof operationRuleCreate>>, TError,{data: OperationRuleCreateBody}, TContext> => {

const mutationKey = ['operationRuleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationRuleCreate>>, {data: OperationRuleCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  operationRuleCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationRuleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof operationRuleCreate>>>
    export type OperationRuleCreateMutationBody = OperationRuleCreateBody
    export type OperationRuleCreateMutationError = unknown

    /**
 * @summary operationRuleCreate
 */
export const useOperationRuleCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationRuleCreate>>, TError,{data: OperationRuleCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationRuleCreate>>,
        TError,
        {data: OperationRuleCreateBody},
        TContext
      > => {

      const mutationOptions = getOperationRuleCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary operationRuleDeleteForProperty
 */
export const getOperationRuleDeleteForPropertyUrl = (propertyId?: number | null,) => {


  

  return `/operation-rules/property/${propertyId}`
}

export const operationRuleDeleteForProperty = async (propertyId?: number | null, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getOperationRuleDeleteForPropertyUrl(propertyId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getOperationRuleDeleteForPropertyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationRuleDeleteForProperty>>, TError,{propertyId?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof operationRuleDeleteForProperty>>, TError,{propertyId?: number | null}, TContext> => {

const mutationKey = ['operationRuleDeleteForProperty'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationRuleDeleteForProperty>>, {propertyId?: number | null}> = (props) => {
          const {propertyId} = props ?? {};

          return  operationRuleDeleteForProperty(propertyId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationRuleDeleteForPropertyMutationResult = NonNullable<Awaited<ReturnType<typeof operationRuleDeleteForProperty>>>
    
    export type OperationRuleDeleteForPropertyMutationError = unknown

    /**
 * @summary operationRuleDeleteForProperty
 */
export const useOperationRuleDeleteForProperty = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationRuleDeleteForProperty>>, TError,{propertyId?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationRuleDeleteForProperty>>,
        TError,
        {propertyId?: number | null},
        TContext
      > => {

      const mutationOptions = getOperationRuleDeleteForPropertyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ownerMemoGet
 */
export const getOwnerMemoGetUrl = (id?: number | null,
    params?: OwnerMemoGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/owner-memos/${id}?${stringifiedParams}` : `/owner-memos/${id}`
}

export const ownerMemoGet = async (id?: number | null,
    params?: OwnerMemoGetParams, options?: RequestInit): Promise<OwnerMemoGet200> => {
  
  return customInstance<OwnerMemoGet200>(getOwnerMemoGetUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getOwnerMemoGetQueryKey = (id?: number | null,
    params?: OwnerMemoGetParams,) => {
    return [`/owner-memos/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getOwnerMemoGetQueryOptions = <TData = Awaited<ReturnType<typeof ownerMemoGet>>, TError = unknown>(id?: number | null,
    params?: OwnerMemoGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerMemoGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOwnerMemoGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ownerMemoGet>>> = ({ signal }) => ownerMemoGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ownerMemoGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OwnerMemoGetQueryResult = NonNullable<Awaited<ReturnType<typeof ownerMemoGet>>>
export type OwnerMemoGetQueryError = unknown


export function useOwnerMemoGet<TData = Awaited<ReturnType<typeof ownerMemoGet>>, TError = unknown>(
 id: undefined |  number | null,
    params: undefined |  OwnerMemoGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerMemoGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ownerMemoGet>>,
          TError,
          Awaited<ReturnType<typeof ownerMemoGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerMemoGet<TData = Awaited<ReturnType<typeof ownerMemoGet>>, TError = unknown>(
 id?: number | null,
    params?: OwnerMemoGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerMemoGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ownerMemoGet>>,
          TError,
          Awaited<ReturnType<typeof ownerMemoGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerMemoGet<TData = Awaited<ReturnType<typeof ownerMemoGet>>, TError = unknown>(
 id?: number | null,
    params?: OwnerMemoGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerMemoGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ownerMemoGet
 */

export function useOwnerMemoGet<TData = Awaited<ReturnType<typeof ownerMemoGet>>, TError = unknown>(
 id?: number | null,
    params?: OwnerMemoGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerMemoGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOwnerMemoGetQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOwnerMemoGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ownerMemoGet>>, TError = unknown>(id?: number | null,
    params?: OwnerMemoGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerMemoGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOwnerMemoGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ownerMemoGet>>> = ({ signal }) => ownerMemoGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerMemoGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OwnerMemoGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ownerMemoGet>>>
export type OwnerMemoGetSuspenseQueryError = unknown


export function useOwnerMemoGetSuspense<TData = Awaited<ReturnType<typeof ownerMemoGet>>, TError = unknown>(
 id: undefined |  number | null,
    params: undefined |  OwnerMemoGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerMemoGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerMemoGetSuspense<TData = Awaited<ReturnType<typeof ownerMemoGet>>, TError = unknown>(
 id?: number | null,
    params?: OwnerMemoGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerMemoGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerMemoGetSuspense<TData = Awaited<ReturnType<typeof ownerMemoGet>>, TError = unknown>(
 id?: number | null,
    params?: OwnerMemoGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerMemoGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ownerMemoGet
 */

export function useOwnerMemoGetSuspense<TData = Awaited<ReturnType<typeof ownerMemoGet>>, TError = unknown>(
 id?: number | null,
    params?: OwnerMemoGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerMemoGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOwnerMemoGetSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary ownerMemoUpdate
 */
export const getOwnerMemoUpdateUrl = (id?: number | null,) => {


  

  return `/owner-memos/${id}`
}

export const ownerMemoUpdate = async (ownerMemoUpdateBody: OwnerMemoUpdateBody,
    id?: number | null, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getOwnerMemoUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ownerMemoUpdateBody,)
  }
);}




export const getOwnerMemoUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ownerMemoUpdate>>, TError,{data: OwnerMemoUpdateBody;id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ownerMemoUpdate>>, TError,{data: OwnerMemoUpdateBody;id?: number | null}, TContext> => {

const mutationKey = ['ownerMemoUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ownerMemoUpdate>>, {data: OwnerMemoUpdateBody;id?: number | null}> = (props) => {
          const {data,id} = props ?? {};

          return  ownerMemoUpdate(data,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OwnerMemoUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof ownerMemoUpdate>>>
    export type OwnerMemoUpdateMutationBody = OwnerMemoUpdateBody
    export type OwnerMemoUpdateMutationError = unknown

    /**
 * @summary ownerMemoUpdate
 */
export const useOwnerMemoUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ownerMemoUpdate>>, TError,{data: OwnerMemoUpdateBody;id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ownerMemoUpdate>>,
        TError,
        {data: OwnerMemoUpdateBody;id?: number | null},
        TContext
      > => {

      const mutationOptions = getOwnerMemoUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ownerMemoDelete
 */
export const getOwnerMemoDeleteUrl = (id?: number | null,) => {


  

  return `/owner-memos/${id}`
}

export const ownerMemoDelete = async (id?: number | null, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getOwnerMemoDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getOwnerMemoDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ownerMemoDelete>>, TError,{id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ownerMemoDelete>>, TError,{id?: number | null}, TContext> => {

const mutationKey = ['ownerMemoDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ownerMemoDelete>>, {id?: number | null}> = (props) => {
          const {id} = props ?? {};

          return  ownerMemoDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OwnerMemoDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof ownerMemoDelete>>>
    
    export type OwnerMemoDeleteMutationError = unknown

    /**
 * @summary ownerMemoDelete
 */
export const useOwnerMemoDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ownerMemoDelete>>, TError,{id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ownerMemoDelete>>,
        TError,
        {id?: number | null},
        TContext
      > => {

      const mutationOptions = getOwnerMemoDeleteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ownerMemoList
 */
export const getOwnerMemoListUrl = (params?: OwnerMemoListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/owner-memos?${stringifiedParams}` : `/owner-memos`
}

export const ownerMemoList = async (params?: OwnerMemoListParams, options?: RequestInit): Promise<OwnerMemoList200> => {
  
  return customInstance<OwnerMemoList200>(getOwnerMemoListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getOwnerMemoListQueryKey = (params?: OwnerMemoListParams,) => {
    return [`/owner-memos`, ...(params ? [params]: [])] as const;
    }

    
export const getOwnerMemoListQueryOptions = <TData = Awaited<ReturnType<typeof ownerMemoList>>, TError = unknown>(params?: OwnerMemoListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerMemoList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOwnerMemoListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ownerMemoList>>> = ({ signal }) => ownerMemoList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ownerMemoList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OwnerMemoListQueryResult = NonNullable<Awaited<ReturnType<typeof ownerMemoList>>>
export type OwnerMemoListQueryError = unknown


export function useOwnerMemoList<TData = Awaited<ReturnType<typeof ownerMemoList>>, TError = unknown>(
 params: undefined |  OwnerMemoListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerMemoList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ownerMemoList>>,
          TError,
          Awaited<ReturnType<typeof ownerMemoList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerMemoList<TData = Awaited<ReturnType<typeof ownerMemoList>>, TError = unknown>(
 params?: OwnerMemoListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerMemoList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ownerMemoList>>,
          TError,
          Awaited<ReturnType<typeof ownerMemoList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerMemoList<TData = Awaited<ReturnType<typeof ownerMemoList>>, TError = unknown>(
 params?: OwnerMemoListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerMemoList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ownerMemoList
 */

export function useOwnerMemoList<TData = Awaited<ReturnType<typeof ownerMemoList>>, TError = unknown>(
 params?: OwnerMemoListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerMemoList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOwnerMemoListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOwnerMemoListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ownerMemoList>>, TError = unknown>(params?: OwnerMemoListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerMemoList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOwnerMemoListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ownerMemoList>>> = ({ signal }) => ownerMemoList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerMemoList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OwnerMemoListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ownerMemoList>>>
export type OwnerMemoListSuspenseQueryError = unknown


export function useOwnerMemoListSuspense<TData = Awaited<ReturnType<typeof ownerMemoList>>, TError = unknown>(
 params: undefined |  OwnerMemoListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerMemoList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerMemoListSuspense<TData = Awaited<ReturnType<typeof ownerMemoList>>, TError = unknown>(
 params?: OwnerMemoListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerMemoList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerMemoListSuspense<TData = Awaited<ReturnType<typeof ownerMemoList>>, TError = unknown>(
 params?: OwnerMemoListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerMemoList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ownerMemoList
 */

export function useOwnerMemoListSuspense<TData = Awaited<ReturnType<typeof ownerMemoList>>, TError = unknown>(
 params?: OwnerMemoListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerMemoList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOwnerMemoListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary ownerMemoCreate
 */
export const getOwnerMemoCreateUrl = () => {


  

  return `/owner-memos`
}

export const ownerMemoCreate = async (ownerMemoCreateBody: OwnerMemoCreateBody, options?: RequestInit): Promise<OwnerMemoCreate201> => {
  
  return customInstance<OwnerMemoCreate201>(getOwnerMemoCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ownerMemoCreateBody,)
  }
);}




export const getOwnerMemoCreateMutationOptions = <TError = OwnerMemoCreate400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ownerMemoCreate>>, TError,{data: OwnerMemoCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ownerMemoCreate>>, TError,{data: OwnerMemoCreateBody}, TContext> => {

const mutationKey = ['ownerMemoCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ownerMemoCreate>>, {data: OwnerMemoCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  ownerMemoCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OwnerMemoCreateMutationResult = NonNullable<Awaited<ReturnType<typeof ownerMemoCreate>>>
    export type OwnerMemoCreateMutationBody = OwnerMemoCreateBody
    export type OwnerMemoCreateMutationError = OwnerMemoCreate400

    /**
 * @summary ownerMemoCreate
 */
export const useOwnerMemoCreate = <TError = OwnerMemoCreate400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ownerMemoCreate>>, TError,{data: OwnerMemoCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ownerMemoCreate>>,
        TError,
        {data: OwnerMemoCreateBody},
        TContext
      > => {

      const mutationOptions = getOwnerMemoCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ownerSummary
 */
export const getOwnerSummaryUrl = () => {


  

  return `/owners/summary`
}

export const ownerSummary = async ( options?: RequestInit): Promise<OwnerSummary200> => {
  
  return customInstance<OwnerSummary200>(getOwnerSummaryUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getOwnerSummaryQueryKey = () => {
    return [`/owners/summary`] as const;
    }

    
export const getOwnerSummaryQueryOptions = <TData = Awaited<ReturnType<typeof ownerSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOwnerSummaryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ownerSummary>>> = ({ signal }) => ownerSummary({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ownerSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OwnerSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof ownerSummary>>>
export type OwnerSummaryQueryError = unknown


export function useOwnerSummary<TData = Awaited<ReturnType<typeof ownerSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ownerSummary>>,
          TError,
          Awaited<ReturnType<typeof ownerSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerSummary<TData = Awaited<ReturnType<typeof ownerSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ownerSummary>>,
          TError,
          Awaited<ReturnType<typeof ownerSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerSummary<TData = Awaited<ReturnType<typeof ownerSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ownerSummary
 */

export function useOwnerSummary<TData = Awaited<ReturnType<typeof ownerSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOwnerSummaryQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOwnerSummarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ownerSummary>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOwnerSummaryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ownerSummary>>> = ({ signal }) => ownerSummary({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OwnerSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ownerSummary>>>
export type OwnerSummarySuspenseQueryError = unknown


export function useOwnerSummarySuspense<TData = Awaited<ReturnType<typeof ownerSummary>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerSummarySuspense<TData = Awaited<ReturnType<typeof ownerSummary>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerSummarySuspense<TData = Awaited<ReturnType<typeof ownerSummary>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ownerSummary
 */

export function useOwnerSummarySuspense<TData = Awaited<ReturnType<typeof ownerSummary>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOwnerSummarySuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary checkStripePaymentMethod
 */
export const getCheckStripePaymentMethodUrl = () => {


  

  return `/owners/check-stripe-payment-method`
}

export const checkStripePaymentMethod = async ( options?: RequestInit): Promise<CheckStripePaymentMethod200> => {
  
  return customInstance<CheckStripePaymentMethod200>(getCheckStripePaymentMethodUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getCheckStripePaymentMethodQueryKey = () => {
    return [`/owners/check-stripe-payment-method`] as const;
    }

    
export const getCheckStripePaymentMethodQueryOptions = <TData = Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckStripePaymentMethodQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkStripePaymentMethod>>> = ({ signal }) => checkStripePaymentMethod({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CheckStripePaymentMethodQueryResult = NonNullable<Awaited<ReturnType<typeof checkStripePaymentMethod>>>
export type CheckStripePaymentMethodQueryError = unknown


export function useCheckStripePaymentMethod<TData = Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkStripePaymentMethod>>,
          TError,
          Awaited<ReturnType<typeof checkStripePaymentMethod>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckStripePaymentMethod<TData = Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkStripePaymentMethod>>,
          TError,
          Awaited<ReturnType<typeof checkStripePaymentMethod>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckStripePaymentMethod<TData = Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary checkStripePaymentMethod
 */

export function useCheckStripePaymentMethod<TData = Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheckStripePaymentMethodQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCheckStripePaymentMethodSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckStripePaymentMethodQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkStripePaymentMethod>>> = ({ signal }) => checkStripePaymentMethod({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CheckStripePaymentMethodSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof checkStripePaymentMethod>>>
export type CheckStripePaymentMethodSuspenseQueryError = unknown


export function useCheckStripePaymentMethodSuspense<TData = Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckStripePaymentMethodSuspense<TData = Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckStripePaymentMethodSuspense<TData = Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary checkStripePaymentMethod
 */

export function useCheckStripePaymentMethodSuspense<TData = Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof checkStripePaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheckStripePaymentMethodSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary agreeEchoesConsent
 */
export const getAgreeEchoesConsentUrl = () => {


  

  return `/owners/echoes/consent`
}

export const agreeEchoesConsent = async (agreeEchoesConsentBody: AgreeEchoesConsentBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getAgreeEchoesConsentUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      agreeEchoesConsentBody,)
  }
);}




export const getAgreeEchoesConsentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agreeEchoesConsent>>, TError,{data: AgreeEchoesConsentBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof agreeEchoesConsent>>, TError,{data: AgreeEchoesConsentBody}, TContext> => {

const mutationKey = ['agreeEchoesConsent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof agreeEchoesConsent>>, {data: AgreeEchoesConsentBody}> = (props) => {
          const {data} = props ?? {};

          return  agreeEchoesConsent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AgreeEchoesConsentMutationResult = NonNullable<Awaited<ReturnType<typeof agreeEchoesConsent>>>
    export type AgreeEchoesConsentMutationBody = AgreeEchoesConsentBody
    export type AgreeEchoesConsentMutationError = unknown

    /**
 * @summary agreeEchoesConsent
 */
export const useAgreeEchoesConsent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agreeEchoesConsent>>, TError,{data: AgreeEchoesConsentBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof agreeEchoesConsent>>,
        TError,
        {data: AgreeEchoesConsentBody},
        TContext
      > => {

      const mutationOptions = getAgreeEchoesConsentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary planGet
 */
export const getPlanGetUrl = (id?: number | null,
    params?: PlanGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/plans/${id}?${stringifiedParams}` : `/plans/${id}`
}

export const planGet = async (id?: number | null,
    params?: PlanGetParams, options?: RequestInit): Promise<PlanGet200> => {
  
  return customInstance<PlanGet200>(getPlanGetUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getPlanGetQueryKey = (id?: number | null,
    params?: PlanGetParams,) => {
    return [`/plans/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getPlanGetQueryOptions = <TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(id?: number | null,
    params?: PlanGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlanGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof planGet>>> = ({ signal }) => planGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlanGetQueryResult = NonNullable<Awaited<ReturnType<typeof planGet>>>
export type PlanGetQueryError = unknown


export function usePlanGet<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id: undefined |  number | null,
    params: undefined |  PlanGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof planGet>>,
          TError,
          Awaited<ReturnType<typeof planGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlanGet<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id?: number | null,
    params?: PlanGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof planGet>>,
          TError,
          Awaited<ReturnType<typeof planGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlanGet<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id?: number | null,
    params?: PlanGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary planGet
 */

export function usePlanGet<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id?: number | null,
    params?: PlanGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlanGetQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPlanGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(id?: number | null,
    params?: PlanGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlanGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof planGet>>> = ({ signal }) => planGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlanGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof planGet>>>
export type PlanGetSuspenseQueryError = unknown


export function usePlanGetSuspense<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id: undefined |  number | null,
    params: undefined |  PlanGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlanGetSuspense<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id?: number | null,
    params?: PlanGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlanGetSuspense<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id?: number | null,
    params?: PlanGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary planGet
 */

export function usePlanGetSuspense<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id?: number | null,
    params?: PlanGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlanGetSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary planDelete
 */
export const getPlanDeleteUrl = (id?: number | null,) => {


  

  return `/plans/${id}`
}

export const planDelete = async (id?: number | null, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getPlanDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getPlanDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planDelete>>, TError,{id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof planDelete>>, TError,{id?: number | null}, TContext> => {

const mutationKey = ['planDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof planDelete>>, {id?: number | null}> = (props) => {
          const {id} = props ?? {};

          return  planDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlanDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof planDelete>>>
    
    export type PlanDeleteMutationError = unknown

    /**
 * @summary planDelete
 */
export const usePlanDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planDelete>>, TError,{id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof planDelete>>,
        TError,
        {id?: number | null},
        TContext
      > => {

      const mutationOptions = getPlanDeleteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary planCreate
 */
export const getPlanCreateUrl = () => {


  

  return `/plans`
}

export const planCreate = async (planCreateBody: PlanCreateBody, options?: RequestInit): Promise<PlanCreate201> => {
  
  return customInstance<PlanCreate201>(getPlanCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      planCreateBody,)
  }
);}




export const getPlanCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planCreate>>, TError,{data: PlanCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof planCreate>>, TError,{data: PlanCreateBody}, TContext> => {

const mutationKey = ['planCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof planCreate>>, {data: PlanCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  planCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlanCreateMutationResult = NonNullable<Awaited<ReturnType<typeof planCreate>>>
    export type PlanCreateMutationBody = PlanCreateBody
    export type PlanCreateMutationError = unknown

    /**
 * @summary planCreate
 */
export const usePlanCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planCreate>>, TError,{data: PlanCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof planCreate>>,
        TError,
        {data: PlanCreateBody},
        TContext
      > => {

      const mutationOptions = getPlanCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary planCancel
 */
export const getPlanCancelUrl = (id?: number | null,) => {


  

  return `/plans/${id}/cancel`
}

export const planCancel = async (planCancelBody: PlanCancelBody,
    id?: number | null, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getPlanCancelUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      planCancelBody,)
  }
);}




export const getPlanCancelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planCancel>>, TError,{data: PlanCancelBody;id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof planCancel>>, TError,{data: PlanCancelBody;id?: number | null}, TContext> => {

const mutationKey = ['planCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof planCancel>>, {data: PlanCancelBody;id?: number | null}> = (props) => {
          const {data,id} = props ?? {};

          return  planCancel(data,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlanCancelMutationResult = NonNullable<Awaited<ReturnType<typeof planCancel>>>
    export type PlanCancelMutationBody = PlanCancelBody
    export type PlanCancelMutationError = unknown

    /**
 * @summary planCancel
 */
export const usePlanCancel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planCancel>>, TError,{data: PlanCancelBody;id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof planCancel>>,
        TError,
        {data: PlanCancelBody;id?: number | null},
        TContext
      > => {

      const mutationOptions = getPlanCancelMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary planRevival
 */
export const getPlanRevivalUrl = (id?: number | null,) => {


  

  return `/plans/${id}/revival`
}

export const planRevival = async (id?: number | null, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getPlanRevivalUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPlanRevivalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planRevival>>, TError,{id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof planRevival>>, TError,{id?: number | null}, TContext> => {

const mutationKey = ['planRevival'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof planRevival>>, {id?: number | null}> = (props) => {
          const {id} = props ?? {};

          return  planRevival(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlanRevivalMutationResult = NonNullable<Awaited<ReturnType<typeof planRevival>>>
    
    export type PlanRevivalMutationError = unknown

    /**
 * @summary planRevival
 */
export const usePlanRevival = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planRevival>>, TError,{id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof planRevival>>,
        TError,
        {id?: number | null},
        TContext
      > => {

      const mutationOptions = getPlanRevivalMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary propertyGet
 */
export const getPropertyGetUrl = (id?: number | null,
    params?: PropertyGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/properties/${id}?${stringifiedParams}` : `/properties/${id}`
}

export const propertyGet = async (id?: number | null,
    params?: PropertyGetParams, options?: RequestInit): Promise<PropertyGet200> => {
  
  return customInstance<PropertyGet200>(getPropertyGetUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getPropertyGetQueryKey = (id?: number | null,
    params?: PropertyGetParams,) => {
    return [`/properties/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getPropertyGetQueryOptions = <TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(id?: number | null,
    params?: PropertyGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPropertyGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof propertyGet>>> = ({ signal }) => propertyGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PropertyGetQueryResult = NonNullable<Awaited<ReturnType<typeof propertyGet>>>
export type PropertyGetQueryError = unknown


export function usePropertyGet<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id: undefined |  number | null,
    params: undefined |  PropertyGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof propertyGet>>,
          TError,
          Awaited<ReturnType<typeof propertyGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyGet<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id?: number | null,
    params?: PropertyGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof propertyGet>>,
          TError,
          Awaited<ReturnType<typeof propertyGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyGet<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id?: number | null,
    params?: PropertyGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary propertyGet
 */

export function usePropertyGet<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id?: number | null,
    params?: PropertyGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPropertyGetQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPropertyGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(id?: number | null,
    params?: PropertyGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPropertyGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof propertyGet>>> = ({ signal }) => propertyGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PropertyGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof propertyGet>>>
export type PropertyGetSuspenseQueryError = unknown


export function usePropertyGetSuspense<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id: undefined |  number | null,
    params: undefined |  PropertyGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyGetSuspense<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id?: number | null,
    params?: PropertyGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyGetSuspense<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id?: number | null,
    params?: PropertyGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary propertyGet
 */

export function usePropertyGetSuspense<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id?: number | null,
    params?: PropertyGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPropertyGetSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary propertyUpdate
 */
export const getPropertyUpdateUrl = (id?: number | null,) => {


  

  return `/properties/${id}`
}

export const propertyUpdate = async (propertyUpdateBody: PropertyUpdateBody,
    id?: number | null, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getPropertyUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      propertyUpdateBody,)
  }
);}




export const getPropertyUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof propertyUpdate>>, TError,{data: PropertyUpdateBody;id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof propertyUpdate>>, TError,{data: PropertyUpdateBody;id?: number | null}, TContext> => {

const mutationKey = ['propertyUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof propertyUpdate>>, {data: PropertyUpdateBody;id?: number | null}> = (props) => {
          const {data,id} = props ?? {};

          return  propertyUpdate(data,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PropertyUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof propertyUpdate>>>
    export type PropertyUpdateMutationBody = PropertyUpdateBody
    export type PropertyUpdateMutationError = unknown

    /**
 * @summary propertyUpdate
 */
export const usePropertyUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof propertyUpdate>>, TError,{data: PropertyUpdateBody;id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof propertyUpdate>>,
        TError,
        {data: PropertyUpdateBody;id?: number | null},
        TContext
      > => {

      const mutationOptions = getPropertyUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary propertyDelete
 */
export const getPropertyDeleteUrl = (id?: number | null,) => {


  

  return `/properties/${id}`
}

export const propertyDelete = async (id?: number | null, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getPropertyDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getPropertyDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof propertyDelete>>, TError,{id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof propertyDelete>>, TError,{id?: number | null}, TContext> => {

const mutationKey = ['propertyDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof propertyDelete>>, {id?: number | null}> = (props) => {
          const {id} = props ?? {};

          return  propertyDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PropertyDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof propertyDelete>>>
    
    export type PropertyDeleteMutationError = unknown

    /**
 * @summary propertyDelete
 */
export const usePropertyDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof propertyDelete>>, TError,{id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof propertyDelete>>,
        TError,
        {id?: number | null},
        TContext
      > => {

      const mutationOptions = getPropertyDeleteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary propertyList
 */
export const getPropertyListUrl = (params?: PropertyListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/properties?${stringifiedParams}` : `/properties`
}

export const propertyList = async (params?: PropertyListParams, options?: RequestInit): Promise<PropertyList200> => {
  
  return customInstance<PropertyList200>(getPropertyListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getPropertyListQueryKey = (params?: PropertyListParams,) => {
    return [`/properties`, ...(params ? [params]: [])] as const;
    }

    
export const getPropertyListQueryOptions = <TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(params?: PropertyListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPropertyListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof propertyList>>> = ({ signal }) => propertyList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PropertyListQueryResult = NonNullable<Awaited<ReturnType<typeof propertyList>>>
export type PropertyListQueryError = unknown


export function usePropertyList<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params: undefined |  PropertyListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof propertyList>>,
          TError,
          Awaited<ReturnType<typeof propertyList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyList<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params?: PropertyListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof propertyList>>,
          TError,
          Awaited<ReturnType<typeof propertyList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyList<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params?: PropertyListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary propertyList
 */

export function usePropertyList<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params?: PropertyListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPropertyListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPropertyListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(params?: PropertyListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPropertyListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof propertyList>>> = ({ signal }) => propertyList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PropertyListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof propertyList>>>
export type PropertyListSuspenseQueryError = unknown


export function usePropertyListSuspense<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params: undefined |  PropertyListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyListSuspense<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params?: PropertyListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyListSuspense<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params?: PropertyListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary propertyList
 */

export function usePropertyListSuspense<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params?: PropertyListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPropertyListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary propertyCreate
 */
export const getPropertyCreateUrl = () => {


  

  return `/properties`
}

export const propertyCreate = async (propertyCreateBody: PropertyCreateBody, options?: RequestInit): Promise<PropertyCreate201> => {
  
  return customInstance<PropertyCreate201>(getPropertyCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      propertyCreateBody,)
  }
);}




export const getPropertyCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof propertyCreate>>, TError,{data: PropertyCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof propertyCreate>>, TError,{data: PropertyCreateBody}, TContext> => {

const mutationKey = ['propertyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof propertyCreate>>, {data: PropertyCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  propertyCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PropertyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof propertyCreate>>>
    export type PropertyCreateMutationBody = PropertyCreateBody
    export type PropertyCreateMutationError = unknown

    /**
 * @summary propertyCreate
 */
export const usePropertyCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof propertyCreate>>, TError,{data: PropertyCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof propertyCreate>>,
        TError,
        {data: PropertyCreateBody},
        TContext
      > => {

      const mutationOptions = getPropertyCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary roomGet
 */
export const getRoomGetUrl = (id?: number | null,
    params?: RoomGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/rooms/${id}?${stringifiedParams}` : `/rooms/${id}`
}

export const roomGet = async (id?: number | null,
    params?: RoomGetParams, options?: RequestInit): Promise<RoomGet200> => {
  
  return customInstance<RoomGet200>(getRoomGetUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getRoomGetQueryKey = (id?: number | null,
    params?: RoomGetParams,) => {
    return [`/rooms/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getRoomGetQueryOptions = <TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(id?: number | null,
    params?: RoomGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoomGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof roomGet>>> = ({ signal }) => roomGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomGetQueryResult = NonNullable<Awaited<ReturnType<typeof roomGet>>>
export type RoomGetQueryError = unknown


export function useRoomGet<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id: undefined |  number | null,
    params: undefined |  RoomGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof roomGet>>,
          TError,
          Awaited<ReturnType<typeof roomGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomGet<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id?: number | null,
    params?: RoomGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof roomGet>>,
          TError,
          Awaited<ReturnType<typeof roomGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomGet<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id?: number | null,
    params?: RoomGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary roomGet
 */

export function useRoomGet<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id?: number | null,
    params?: RoomGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoomGetQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getRoomGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(id?: number | null,
    params?: RoomGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoomGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof roomGet>>> = ({ signal }) => roomGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof roomGet>>>
export type RoomGetSuspenseQueryError = unknown


export function useRoomGetSuspense<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id: undefined |  number | null,
    params: undefined |  RoomGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomGetSuspense<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id?: number | null,
    params?: RoomGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomGetSuspense<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id?: number | null,
    params?: RoomGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary roomGet
 */

export function useRoomGetSuspense<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id?: number | null,
    params?: RoomGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoomGetSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary roomUpdate
 */
export const getRoomUpdateUrl = (id?: number | null,) => {


  

  return `/rooms/${id}`
}

export const roomUpdate = async (roomUpdateBody: RoomUpdateBody,
    id?: number | null, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getRoomUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roomUpdateBody,)
  }
);}




export const getRoomUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomUpdate>>, TError,{data: RoomUpdateBody;id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof roomUpdate>>, TError,{data: RoomUpdateBody;id?: number | null}, TContext> => {

const mutationKey = ['roomUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof roomUpdate>>, {data: RoomUpdateBody;id?: number | null}> = (props) => {
          const {data,id} = props ?? {};

          return  roomUpdate(data,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RoomUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof roomUpdate>>>
    export type RoomUpdateMutationBody = RoomUpdateBody
    export type RoomUpdateMutationError = unknown

    /**
 * @summary roomUpdate
 */
export const useRoomUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomUpdate>>, TError,{data: RoomUpdateBody;id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof roomUpdate>>,
        TError,
        {data: RoomUpdateBody;id?: number | null},
        TContext
      > => {

      const mutationOptions = getRoomUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary roomDelete
 */
export const getRoomDeleteUrl = (id?: number | null,) => {


  

  return `/rooms/${id}`
}

export const roomDelete = async (id?: number | null, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getRoomDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getRoomDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomDelete>>, TError,{id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof roomDelete>>, TError,{id?: number | null}, TContext> => {

const mutationKey = ['roomDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof roomDelete>>, {id?: number | null}> = (props) => {
          const {id} = props ?? {};

          return  roomDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RoomDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof roomDelete>>>
    
    export type RoomDeleteMutationError = unknown

    /**
 * @summary roomDelete
 */
export const useRoomDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomDelete>>, TError,{id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof roomDelete>>,
        TError,
        {id?: number | null},
        TContext
      > => {

      const mutationOptions = getRoomDeleteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary roomList
 */
export const getRoomListUrl = (params?: RoomListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/rooms?${stringifiedParams}` : `/rooms`
}

export const roomList = async (params?: RoomListParams, options?: RequestInit): Promise<RoomList200> => {
  
  return customInstance<RoomList200>(getRoomListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getRoomListQueryKey = (params?: RoomListParams,) => {
    return [`/rooms`, ...(params ? [params]: [])] as const;
    }

    
export const getRoomListQueryOptions = <TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(params?: RoomListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoomListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof roomList>>> = ({ signal }) => roomList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomListQueryResult = NonNullable<Awaited<ReturnType<typeof roomList>>>
export type RoomListQueryError = unknown


export function useRoomList<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params: undefined |  RoomListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof roomList>>,
          TError,
          Awaited<ReturnType<typeof roomList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomList<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params?: RoomListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof roomList>>,
          TError,
          Awaited<ReturnType<typeof roomList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomList<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params?: RoomListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary roomList
 */

export function useRoomList<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params?: RoomListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoomListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getRoomListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(params?: RoomListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoomListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof roomList>>> = ({ signal }) => roomList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof roomList>>>
export type RoomListSuspenseQueryError = unknown


export function useRoomListSuspense<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params: undefined |  RoomListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomListSuspense<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params?: RoomListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomListSuspense<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params?: RoomListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary roomList
 */

export function useRoomListSuspense<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params?: RoomListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoomListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary roomCreate
 */
export const getRoomCreateUrl = () => {


  

  return `/rooms`
}

export const roomCreate = async (roomCreateBody: RoomCreateBody, options?: RequestInit): Promise<RoomCreate201> => {
  
  return customInstance<RoomCreate201>(getRoomCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roomCreateBody,)
  }
);}




export const getRoomCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomCreate>>, TError,{data: RoomCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof roomCreate>>, TError,{data: RoomCreateBody}, TContext> => {

const mutationKey = ['roomCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof roomCreate>>, {data: RoomCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  roomCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RoomCreateMutationResult = NonNullable<Awaited<ReturnType<typeof roomCreate>>>
    export type RoomCreateMutationBody = RoomCreateBody
    export type RoomCreateMutationError = unknown

    /**
 * @summary roomCreate
 */
export const useRoomCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomCreate>>, TError,{data: RoomCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof roomCreate>>,
        TError,
        {data: RoomCreateBody},
        TContext
      > => {

      const mutationOptions = getRoomCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary tenantGet
 */
export const getTenantGetUrl = (id?: number | null,
    params?: TenantGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tenants/${id}?${stringifiedParams}` : `/tenants/${id}`
}

export const tenantGet = async (id?: number | null,
    params?: TenantGetParams, options?: RequestInit): Promise<TenantGet200> => {
  
  return customInstance<TenantGet200>(getTenantGetUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getTenantGetQueryKey = (id?: number | null,
    params?: TenantGetParams,) => {
    return [`/tenants/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getTenantGetQueryOptions = <TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(id?: number | null,
    params?: TenantGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantGet>>> = ({ signal }) => tenantGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantGetQueryResult = NonNullable<Awaited<ReturnType<typeof tenantGet>>>
export type TenantGetQueryError = unknown


export function useTenantGet<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id: undefined |  number | null,
    params: undefined |  TenantGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantGet>>,
          TError,
          Awaited<ReturnType<typeof tenantGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantGet<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id?: number | null,
    params?: TenantGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantGet>>,
          TError,
          Awaited<ReturnType<typeof tenantGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantGet<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id?: number | null,
    params?: TenantGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary tenantGet
 */

export function useTenantGet<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id?: number | null,
    params?: TenantGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantGetQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTenantGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(id?: number | null,
    params?: TenantGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantGet>>> = ({ signal }) => tenantGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof tenantGet>>>
export type TenantGetSuspenseQueryError = unknown


export function useTenantGetSuspense<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id: undefined |  number | null,
    params: undefined |  TenantGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantGetSuspense<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id?: number | null,
    params?: TenantGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantGetSuspense<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id?: number | null,
    params?: TenantGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary tenantGet
 */

export function useTenantGetSuspense<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id?: number | null,
    params?: TenantGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantGetSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary tenantUpdate
 */
export const getTenantUpdateUrl = (id: string,) => {


  

  return `/tenants/${id}`
}

export const tenantUpdate = async (id: string,
    tenantUpdateBody: TenantUpdateBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTenantUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tenantUpdateBody,)
  }
);}




export const getTenantUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantUpdate>>, TError,{id: string;data: TenantUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tenantUpdate>>, TError,{id: string;data: TenantUpdateBody}, TContext> => {

const mutationKey = ['tenantUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantUpdate>>, {id: string;data: TenantUpdateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  tenantUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TenantUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof tenantUpdate>>>
    export type TenantUpdateMutationBody = TenantUpdateBody
    export type TenantUpdateMutationError = unknown

    /**
 * @summary tenantUpdate
 */
export const useTenantUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantUpdate>>, TError,{id: string;data: TenantUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tenantUpdate>>,
        TError,
        {id: string;data: TenantUpdateBody},
        TContext
      > => {

      const mutationOptions = getTenantUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary tenantDelete
 */
export const getTenantDeleteUrl = (id?: number | null,) => {


  

  return `/tenants/${id}`
}

export const tenantDelete = async (id?: number | null, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTenantDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getTenantDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantDelete>>, TError,{id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tenantDelete>>, TError,{id?: number | null}, TContext> => {

const mutationKey = ['tenantDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantDelete>>, {id?: number | null}> = (props) => {
          const {id} = props ?? {};

          return  tenantDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TenantDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof tenantDelete>>>
    
    export type TenantDeleteMutationError = unknown

    /**
 * @summary tenantDelete
 */
export const useTenantDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantDelete>>, TError,{id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tenantDelete>>,
        TError,
        {id?: number | null},
        TContext
      > => {

      const mutationOptions = getTenantDeleteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary tenantCreate
 */
export const getTenantCreateUrl = () => {


  

  return `/tenants`
}

export const tenantCreate = async (tenantCreateBody: TenantCreateBody, options?: RequestInit): Promise<TenantCreate201> => {
  
  return customInstance<TenantCreate201>(getTenantCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tenantCreateBody,)
  }
);}




export const getTenantCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantCreate>>, TError,{data: TenantCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tenantCreate>>, TError,{data: TenantCreateBody}, TContext> => {

const mutationKey = ['tenantCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantCreate>>, {data: TenantCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  tenantCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TenantCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tenantCreate>>>
    export type TenantCreateMutationBody = TenantCreateBody
    export type TenantCreateMutationError = unknown

    /**
 * @summary tenantCreate
 */
export const useTenantCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantCreate>>, TError,{data: TenantCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tenantCreate>>,
        TError,
        {data: TenantCreateBody},
        TContext
      > => {

      const mutationOptions = getTenantCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary tenantCancel
 */
export const getTenantCancelUrl = (id?: number | null,) => {


  

  return `/tenants/${id}/cancel`
}

export const tenantCancel = async (tenantCancelBody: TenantCancelBody,
    id?: number | null, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTenantCancelUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tenantCancelBody,)
  }
);}




export const getTenantCancelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantCancel>>, TError,{data: TenantCancelBody;id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tenantCancel>>, TError,{data: TenantCancelBody;id?: number | null}, TContext> => {

const mutationKey = ['tenantCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantCancel>>, {data: TenantCancelBody;id?: number | null}> = (props) => {
          const {data,id} = props ?? {};

          return  tenantCancel(data,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TenantCancelMutationResult = NonNullable<Awaited<ReturnType<typeof tenantCancel>>>
    export type TenantCancelMutationBody = TenantCancelBody
    export type TenantCancelMutationError = unknown

    /**
 * @summary tenantCancel
 */
export const useTenantCancel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantCancel>>, TError,{data: TenantCancelBody;id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tenantCancel>>,
        TError,
        {data: TenantCancelBody;id?: number | null},
        TContext
      > => {

      const mutationOptions = getTenantCancelMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary tenantRevival
 */
export const getTenantRevivalUrl = (id?: number | null,) => {


  

  return `/tenants/${id}/revival`
}

export const tenantRevival = async (id?: number | null, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTenantRevivalUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getTenantRevivalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantRevival>>, TError,{id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tenantRevival>>, TError,{id?: number | null}, TContext> => {

const mutationKey = ['tenantRevival'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantRevival>>, {id?: number | null}> = (props) => {
          const {id} = props ?? {};

          return  tenantRevival(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TenantRevivalMutationResult = NonNullable<Awaited<ReturnType<typeof tenantRevival>>>
    
    export type TenantRevivalMutationError = unknown

    /**
 * @summary tenantRevival
 */
export const useTenantRevival = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantRevival>>, TError,{id?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tenantRevival>>,
        TError,
        {id?: number | null},
        TContext
      > => {

      const mutationOptions = getTenantRevivalMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary tenantApplicationGet
 */
export const getTenantApplicationGetUrl = (id: string,
    params?: TenantApplicationGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tenant-applications/${id}?${stringifiedParams}` : `/tenant-applications/${id}`
}

export const tenantApplicationGet = async (id: string,
    params?: TenantApplicationGetParams, options?: RequestInit): Promise<TenantApplicationGet200> => {
  
  return customInstance<TenantApplicationGet200>(getTenantApplicationGetUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getTenantApplicationGetQueryKey = (id?: string,
    params?: TenantApplicationGetParams,) => {
    return [`/tenant-applications/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getTenantApplicationGetQueryOptions = <TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantApplicationGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantApplicationGet>>> = ({ signal }) => tenantApplicationGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantApplicationGetQueryResult = NonNullable<Awaited<ReturnType<typeof tenantApplicationGet>>>
export type TenantApplicationGetQueryError = unknown


export function useTenantApplicationGet<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params: undefined |  TenantApplicationGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantApplicationGet>>,
          TError,
          Awaited<ReturnType<typeof tenantApplicationGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantApplicationGet<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantApplicationGet>>,
          TError,
          Awaited<ReturnType<typeof tenantApplicationGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantApplicationGet<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary tenantApplicationGet
 */

export function useTenantApplicationGet<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantApplicationGetQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTenantApplicationGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantApplicationGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantApplicationGet>>> = ({ signal }) => tenantApplicationGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantApplicationGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof tenantApplicationGet>>>
export type TenantApplicationGetSuspenseQueryError = unknown


export function useTenantApplicationGetSuspense<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params: undefined |  TenantApplicationGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantApplicationGetSuspense<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantApplicationGetSuspense<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary tenantApplicationGet
 */

export function useTenantApplicationGetSuspense<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantApplicationGetSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary tenantApplicationUpdate
 */
export const getTenantApplicationUpdateUrl = (id: number,) => {


  

  return `/tenant-applications/${id}`
}

export const tenantApplicationUpdate = async (id: number,
    tenantApplicationUpdateBody: TenantApplicationUpdateBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTenantApplicationUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tenantApplicationUpdateBody,)
  }
);}




export const getTenantApplicationUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantApplicationUpdate>>, TError,{id: number;data: TenantApplicationUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tenantApplicationUpdate>>, TError,{id: number;data: TenantApplicationUpdateBody}, TContext> => {

const mutationKey = ['tenantApplicationUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantApplicationUpdate>>, {id: number;data: TenantApplicationUpdateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  tenantApplicationUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TenantApplicationUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof tenantApplicationUpdate>>>
    export type TenantApplicationUpdateMutationBody = TenantApplicationUpdateBody
    export type TenantApplicationUpdateMutationError = unknown

    /**
 * @summary tenantApplicationUpdate
 */
export const useTenantApplicationUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantApplicationUpdate>>, TError,{id: number;data: TenantApplicationUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tenantApplicationUpdate>>,
        TError,
        {id: number;data: TenantApplicationUpdateBody},
        TContext
      > => {

      const mutationOptions = getTenantApplicationUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary tenantApplicationCreate
 */
export const getTenantApplicationCreateUrl = () => {


  

  return `/tenant-applications`
}

export const tenantApplicationCreate = async (tenantApplicationCreateBody: TenantApplicationCreateBody, options?: RequestInit): Promise<TenantApplicationCreate201> => {
  
  return customInstance<TenantApplicationCreate201>(getTenantApplicationCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tenantApplicationCreateBody,)
  }
);}




export const getTenantApplicationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantApplicationCreate>>, TError,{data: TenantApplicationCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tenantApplicationCreate>>, TError,{data: TenantApplicationCreateBody}, TContext> => {

const mutationKey = ['tenantApplicationCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantApplicationCreate>>, {data: TenantApplicationCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  tenantApplicationCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TenantApplicationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tenantApplicationCreate>>>
    export type TenantApplicationCreateMutationBody = TenantApplicationCreateBody
    export type TenantApplicationCreateMutationError = unknown

    /**
 * @summary tenantApplicationCreate
 */
export const useTenantApplicationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantApplicationCreate>>, TError,{data: TenantApplicationCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tenantApplicationCreate>>,
        TError,
        {data: TenantApplicationCreateBody},
        TContext
      > => {

      const mutationOptions = getTenantApplicationCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary tenantApplicationUpdateStatus
 */
export const getTenantApplicationUpdateStatusUrl = (id: number,) => {


  

  return `/tenant-applications/${id}/status`
}

export const tenantApplicationUpdateStatus = async (id: number,
    tenantApplicationUpdateStatusBody: TenantApplicationUpdateStatusBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTenantApplicationUpdateStatusUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tenantApplicationUpdateStatusBody,)
  }
);}




export const getTenantApplicationUpdateStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantApplicationUpdateStatus>>, TError,{id: number;data: TenantApplicationUpdateStatusBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tenantApplicationUpdateStatus>>, TError,{id: number;data: TenantApplicationUpdateStatusBody}, TContext> => {

const mutationKey = ['tenantApplicationUpdateStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantApplicationUpdateStatus>>, {id: number;data: TenantApplicationUpdateStatusBody}> = (props) => {
          const {id,data} = props ?? {};

          return  tenantApplicationUpdateStatus(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TenantApplicationUpdateStatusMutationResult = NonNullable<Awaited<ReturnType<typeof tenantApplicationUpdateStatus>>>
    export type TenantApplicationUpdateStatusMutationBody = TenantApplicationUpdateStatusBody
    export type TenantApplicationUpdateStatusMutationError = unknown

    /**
 * @summary tenantApplicationUpdateStatus
 */
export const useTenantApplicationUpdateStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantApplicationUpdateStatus>>, TError,{id: number;data: TenantApplicationUpdateStatusBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tenantApplicationUpdateStatus>>,
        TError,
        {id: number;data: TenantApplicationUpdateStatusBody},
        TContext
      > => {

      const mutationOptions = getTenantApplicationUpdateStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketGet
 */
export const getTicketGetUrl = (id: string,
    params?: TicketGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tickets/${id}?${stringifiedParams}` : `/tickets/${id}`
}

export const ticketGet = async (id: string,
    params?: TicketGetParams, options?: RequestInit): Promise<TicketGet200> => {
  
  return customInstance<TicketGet200>(getTicketGetUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getTicketGetQueryKey = (id?: string,
    params?: TicketGetParams,) => {
    return [`/tickets/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getTicketGetQueryOptions = <TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTicketGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ticketGet>>> = ({ signal }) => ticketGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TicketGetQueryResult = NonNullable<Awaited<ReturnType<typeof ticketGet>>>
export type TicketGetQueryError = unknown


export function useTicketGet<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params: undefined |  TicketGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ticketGet>>,
          TError,
          Awaited<ReturnType<typeof ticketGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketGet<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ticketGet>>,
          TError,
          Awaited<ReturnType<typeof ticketGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketGet<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ticketGet
 */

export function useTicketGet<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTicketGetQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTicketGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTicketGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ticketGet>>> = ({ signal }) => ticketGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TicketGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ticketGet>>>
export type TicketGetSuspenseQueryError = unknown


export function useTicketGetSuspense<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params: undefined |  TicketGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketGetSuspense<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketGetSuspense<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ticketGet
 */

export function useTicketGetSuspense<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTicketGetSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary ticketUpdate
 */
export const getTicketUpdateUrl = (id: string,) => {


  

  return `/tickets/${id}`
}

export const ticketUpdate = async (id: string,
    ticketUpdateBody: TicketUpdateBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTicketUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketUpdateBody,)
  }
);}




export const getTicketUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketUpdate>>, TError,{id: string;data: TicketUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketUpdate>>, TError,{id: string;data: TicketUpdateBody}, TContext> => {

const mutationKey = ['ticketUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketUpdate>>, {id: string;data: TicketUpdateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  ticketUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof ticketUpdate>>>
    export type TicketUpdateMutationBody = TicketUpdateBody
    export type TicketUpdateMutationError = unknown

    /**
 * @summary ticketUpdate
 */
export const useTicketUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketUpdate>>, TError,{id: string;data: TicketUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketUpdate>>,
        TError,
        {id: string;data: TicketUpdateBody},
        TContext
      > => {

      const mutationOptions = getTicketUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketList
 */
export const getTicketListUrl = (params?: TicketListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tickets?${stringifiedParams}` : `/tickets`
}

export const ticketList = async (params?: TicketListParams, options?: RequestInit): Promise<TicketList200> => {
  
  return customInstance<TicketList200>(getTicketListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getTicketListQueryKey = (params?: TicketListParams,) => {
    return [`/tickets`, ...(params ? [params]: [])] as const;
    }

    
export const getTicketListQueryOptions = <TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(params?: TicketListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTicketListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ticketList>>> = ({ signal }) => ticketList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TicketListQueryResult = NonNullable<Awaited<ReturnType<typeof ticketList>>>
export type TicketListQueryError = unknown


export function useTicketList<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params: undefined |  TicketListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ticketList>>,
          TError,
          Awaited<ReturnType<typeof ticketList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketList<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params?: TicketListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ticketList>>,
          TError,
          Awaited<ReturnType<typeof ticketList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketList<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params?: TicketListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ticketList
 */

export function useTicketList<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params?: TicketListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTicketListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTicketListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(params?: TicketListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTicketListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ticketList>>> = ({ signal }) => ticketList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TicketListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ticketList>>>
export type TicketListSuspenseQueryError = unknown


export function useTicketListSuspense<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params: undefined |  TicketListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketListSuspense<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params?: TicketListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketListSuspense<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params?: TicketListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ticketList
 */

export function useTicketListSuspense<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params?: TicketListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTicketListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary ticketCreate
 */
export const getTicketCreateUrl = () => {


  

  return `/tickets`
}

export const ticketCreate = async (ticketCreateBody: TicketCreateBody, options?: RequestInit): Promise<TicketCreate201> => {
  
  return customInstance<TicketCreate201>(getTicketCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketCreateBody,)
  }
);}




export const getTicketCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketCreate>>, TError,{data: TicketCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketCreate>>, TError,{data: TicketCreateBody}, TContext> => {

const mutationKey = ['ticketCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketCreate>>, {data: TicketCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  ticketCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketCreateMutationResult = NonNullable<Awaited<ReturnType<typeof ticketCreate>>>
    export type TicketCreateMutationBody = TicketCreateBody
    export type TicketCreateMutationError = unknown

    /**
 * @summary ticketCreate
 */
export const useTicketCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketCreate>>, TError,{data: TicketCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketCreate>>,
        TError,
        {data: TicketCreateBody},
        TContext
      > => {

      const mutationOptions = getTicketCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketUpdateContractor
 */
export const getTicketUpdateContractorUrl = (id: string,) => {


  

  return `/tickets/${id}/contractor`
}

export const ticketUpdateContractor = async (id: string,
    ticketUpdateContractorBody: TicketUpdateContractorBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTicketUpdateContractorUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketUpdateContractorBody,)
  }
);}




export const getTicketUpdateContractorMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketUpdateContractor>>, TError,{id: string;data: TicketUpdateContractorBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketUpdateContractor>>, TError,{id: string;data: TicketUpdateContractorBody}, TContext> => {

const mutationKey = ['ticketUpdateContractor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketUpdateContractor>>, {id: string;data: TicketUpdateContractorBody}> = (props) => {
          const {id,data} = props ?? {};

          return  ticketUpdateContractor(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketUpdateContractorMutationResult = NonNullable<Awaited<ReturnType<typeof ticketUpdateContractor>>>
    export type TicketUpdateContractorMutationBody = TicketUpdateContractorBody
    export type TicketUpdateContractorMutationError = unknown

    /**
 * @summary ticketUpdateContractor
 */
export const useTicketUpdateContractor = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketUpdateContractor>>, TError,{id: string;data: TicketUpdateContractorBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketUpdateContractor>>,
        TError,
        {id: string;data: TicketUpdateContractorBody},
        TContext
      > => {

      const mutationOptions = getTicketUpdateContractorMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketMessageList
 */
export const getTicketMessageListUrl = (ticketId: string,
    params?: TicketMessageListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/ticket_messages/${ticketId}?${stringifiedParams}` : `/ticket_messages/${ticketId}`
}

export const ticketMessageList = async (ticketId: string,
    params?: TicketMessageListParams, options?: RequestInit): Promise<TicketMessageList200> => {
  
  return customInstance<TicketMessageList200>(getTicketMessageListUrl(ticketId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getTicketMessageListQueryKey = (ticketId?: string,
    params?: TicketMessageListParams,) => {
    return [`/ticket_messages/${ticketId}`, ...(params ? [params]: [])] as const;
    }

    
export const getTicketMessageListQueryOptions = <TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTicketMessageListQueryKey(ticketId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ticketMessageList>>> = ({ signal }) => ticketMessageList(ticketId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(ticketId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TicketMessageListQueryResult = NonNullable<Awaited<ReturnType<typeof ticketMessageList>>>
export type TicketMessageListQueryError = unknown


export function useTicketMessageList<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params: undefined |  TicketMessageListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ticketMessageList>>,
          TError,
          Awaited<ReturnType<typeof ticketMessageList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketMessageList<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ticketMessageList>>,
          TError,
          Awaited<ReturnType<typeof ticketMessageList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketMessageList<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ticketMessageList
 */

export function useTicketMessageList<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTicketMessageListQueryOptions(ticketId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTicketMessageListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTicketMessageListQueryKey(ticketId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ticketMessageList>>> = ({ signal }) => ticketMessageList(ticketId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TicketMessageListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ticketMessageList>>>
export type TicketMessageListSuspenseQueryError = unknown


export function useTicketMessageListSuspense<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params: undefined |  TicketMessageListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketMessageListSuspense<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketMessageListSuspense<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ticketMessageList
 */

export function useTicketMessageListSuspense<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTicketMessageListSuspenseQueryOptions(ticketId,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary ticketMessageCreate
 */
export const getTicketMessageCreateUrl = (ticketId: string,) => {


  

  return `/ticket_messages/${ticketId}`
}

export const ticketMessageCreate = async (ticketId: string,
    ticketMessageCreateBody: TicketMessageCreateBody, options?: RequestInit): Promise<TicketMessageCreate201> => {
  
  return customInstance<TicketMessageCreate201>(getTicketMessageCreateUrl(ticketId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketMessageCreateBody,)
  }
);}




export const getTicketMessageCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketMessageCreate>>, TError,{ticketId: string;data: TicketMessageCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketMessageCreate>>, TError,{ticketId: string;data: TicketMessageCreateBody}, TContext> => {

const mutationKey = ['ticketMessageCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketMessageCreate>>, {ticketId: string;data: TicketMessageCreateBody}> = (props) => {
          const {ticketId,data} = props ?? {};

          return  ticketMessageCreate(ticketId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketMessageCreateMutationResult = NonNullable<Awaited<ReturnType<typeof ticketMessageCreate>>>
    export type TicketMessageCreateMutationBody = TicketMessageCreateBody
    export type TicketMessageCreateMutationError = unknown

    /**
 * @summary ticketMessageCreate
 */
export const useTicketMessageCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketMessageCreate>>, TError,{ticketId: string;data: TicketMessageCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketMessageCreate>>,
        TError,
        {ticketId: string;data: TicketMessageCreateBody},
        TContext
      > => {

      const mutationOptions = getTicketMessageCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketMessageMarkAllAsRead
 */
export const getTicketMessageMarkAllAsReadUrl = (ticketId: string,) => {


  

  return `/ticket_messages/${ticketId}/read`
}

export const ticketMessageMarkAllAsRead = async (ticketId: string, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTicketMessageMarkAllAsReadUrl(ticketId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getTicketMessageMarkAllAsReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketMessageMarkAllAsRead>>, TError,{ticketId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketMessageMarkAllAsRead>>, TError,{ticketId: string}, TContext> => {

const mutationKey = ['ticketMessageMarkAllAsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketMessageMarkAllAsRead>>, {ticketId: string}> = (props) => {
          const {ticketId} = props ?? {};

          return  ticketMessageMarkAllAsRead(ticketId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketMessageMarkAllAsReadMutationResult = NonNullable<Awaited<ReturnType<typeof ticketMessageMarkAllAsRead>>>
    
    export type TicketMessageMarkAllAsReadMutationError = unknown

    /**
 * @summary ticketMessageMarkAllAsRead
 */
export const useTicketMessageMarkAllAsRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketMessageMarkAllAsRead>>, TError,{ticketId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketMessageMarkAllAsRead>>,
        TError,
        {ticketId: string},
        TContext
      > => {

      const mutationOptions = getTicketMessageMarkAllAsReadMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
